module.exports = __webpack_public_path__ + "assets/img/Future_Macaron.7b043bef-ps.jpg";